export function signupHref(
  returnTo: string,
  mode: 'signup' | 'login' = 'signup',
): string {
  const url = `/auth/login?returnTo=${encodeURIComponent(returnTo)}`;
  return mode === 'signup' ? `${url}&screen_hint=signup` : url;
}

/**
 * Tracks a guest "Sign up" button click via sendBeacon, then redirects to Auth0.
 * sendBeacon is fire-and-forget — it survives page navigation.
 */
export function trackSignupAndRedirect(
  pathname: string,
  source: string,
  companyId?: string,
  mode: 'signup' | 'login' = 'signup',
) {
  try {
    navigator.sendBeacon(
      '/api/auth/signup-click',
      new Blob([JSON.stringify({ source, companyId, pathname })], {
        type: 'application/json',
      }),
    );
  } catch {
    // Silently ignore — tracking must never block navigation
  }
  window.location.href = signupHref(pathname, mode);
}
